
import React from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import CompanyForm from "@/components/CompanyForm";
import { Company } from "@/lib/types";

// Loading state component
export const LoadingState = () => (
  <div className="flex items-center justify-center h-64">
    <Loader2 className="h-8 w-8 animate-spin text-redflags-red" />
    <p className="ml-2">Loading company details...</p>
  </div>
);

// Not found state component
export const NotFoundState = () => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col items-center justify-center h-64 space-y-4">
      <h1 className="text-xl font-semibold text-redflags-dark">Company not found</h1>
      <p>The company you are looking for does not exist or has been removed.</p>
      <button 
        onClick={() => navigate("/admin/dashboard")}
        className="text-redflags-red hover:underline"
      >
        Return to dashboard
      </button>
    </div>
  );
};

// Edit form component
export const EditCompanyForm = ({ 
  company, 
  onSubmit, 
  onCancel 
}: { 
  company: Company, 
  onSubmit: (data: any) => void, 
  onCancel: () => void 
}) => (
  <div className="max-w-3xl mx-auto">
    <h1 className="text-2xl font-bold mb-6">Edit Company</h1>
    <CompanyForm
      initialValues={{
        name: company.name,
        location: company.locations[0] || "",
        bio: company.bio || "",
        staffSize: company.staffSize || "",
        logo: company.logo || "",
        website: company.website || "",
        twitterUrl: company.twitterUrl || "",
        instagramUrl: company.instagramUrl || "",
        linkedinUrl: company.linkedinUrl || "",
      }}
      onSubmit={onSubmit}
      onCancel={onCancel}
      submitButtonText="Update Company"
    />
  </div>
);
